export const ENV = process.env.REACT_APP_NODE_ENV;

export const PYTHON_API = process.env.REACT_APP_PYTHON_URL;
export const LAYER1_API = process.env.REACT_APP_LAYER1_API_URL;
export const FIREBASE_FUNCTIONS_URL =
  process.env.REACT_APP_FIREBASE_FUNCTIONS_URL;
export const DASHBOARD_API_HOST =
  process.env.REACT_APP_DASHBOARD_API_HOST;

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const SENTRY_DNS = process.env.REACT_APP_SENTRY;

export const TALENTPOOL_APP = process.env.REACT_APP_TALENTPOOL_URL;
export const CANDIDATE_PORTAL_APP = process.env.REACT_APP_CANDIDATE_PORTAL_URL;
export const JOBS_PORTAL_APP = process.env.REACT_APP_JOBS_PORTAL_URL;

export const LIONSTEP_INTERNAL_TOKEN =
  process.env.REACT_APP_LIONSTEP_INTERNAL_TOKEN;

export const ZENDESK_URL = 'https://lionstep.zendesk.com';
